var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.places,"menu-props":"auto","label":"Miasto","hide-details":"","append-outer-icon":"map","single-line":"","item-text":"name","item-value":"id","error-messages":_vm.placeErrors,"required":""},on:{"change":_vm.returnValue},model:{value:(_vm.place),callback:function ($$v) {_vm.place=$$v},expression:"place"}})
}
var staticRenderFns = []

export { render, staticRenderFns }